<button nz-button nzType="link" (click)="openModal.set(true)">
  <span nz-icon nzType="file-protect"></span>
  <span>{{ 'shared.encrypt.title' | translate }}</span>
</button>

<nz-modal
  nzCentered
  nzMaskClosable="false"
  [nzWidth]="600"
  [nzTitle]="'shared.encrypt.title' | translate"
  [nzVisible]="openModal()"
  (nzOnCancel)="openModal.set(false)"
>
  <ng-container *nzModalContent>
    <form
      #form="ngForm"
      nz-form
      [formGroup]="encryptForm"
      (ngSubmit)="onEncryptionSubmit()"
    >
      <nz-form-item>
        <nz-form-control
          [nzErrorTip]="'shared.encrypt.title' | fieldValidationMsg"
        >
          <textarea
            nz-input
            formControlName="value"
            rows="4"
            [placeholder]="'shared.encrypt.valuePlaceholder' | translate"
          ></textarea>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <textarea
          rows="4"
          nz-input
          [value]="encryptedResult()"
          [disabled]="true"
        ></textarea>
      </nz-form-item>
    </form>
  </ng-container>

  <ng-container *nzModalFooter>
    <button nz-button nzType="primary" (click)="ngForm().ngSubmit.emit()">
      {{ 'shared.encrypt.encryptAndCopyBtn' | translate }}
    </button>

    <button type="button" nz-button (click)="openModal.set(false)">
      {{ 'global.cancel' | translate }}
    </button>
  </ng-container>
</nz-modal>
